var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "power-add-dialog" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "interfaceForm",
            attrs: {
              "label-position": "right",
              model: _vm.interfaceForm,
              rules: _vm.rules,
              "label-width": "120px"
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "资源类型：", prop: "type" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", placeholder: "请选择资源类型" },
                    model: {
                      value: _vm.interfaceForm.type,
                      callback: function($$v) {
                        _vm.$set(_vm.interfaceForm, "type", $$v)
                      },
                      expression: "interfaceForm.type"
                    }
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "类型1", value: "shanghai" }
                    }),
                    _c("el-option", {
                      attrs: { label: "类型2", value: "beijing" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "资源编号：", prop: "num" } },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入角色编号" },
                  model: {
                    value: _vm.interfaceForm.num,
                    callback: function($$v) {
                      _vm.$set(_vm.interfaceForm, "num", $$v)
                    },
                    expression: "interfaceForm.num"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "资源名称：", prop: "name" } },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入资源名称" },
                  model: {
                    value: _vm.interfaceForm.name,
                    callback: function($$v) {
                      _vm.$set(_vm.interfaceForm, "name", $$v)
                    },
                    expression: "interfaceForm.name"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "系统名称：", prop: "sysName" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", placeholder: "请选择资源类型" },
                    model: {
                      value: _vm.interfaceForm.sysName,
                      callback: function($$v) {
                        _vm.$set(_vm.interfaceForm, "sysName", $$v)
                      },
                      expression: "interfaceForm.sysName"
                    }
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "类型1", value: "shanghai" }
                    }),
                    _c("el-option", {
                      attrs: { label: "类型2", value: "beijing" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "资源路径：" } },
              [
                _c("el-input", {
                  attrs: {
                    size: "small",
                    type: "textarea",
                    placeholder: "请输入资源路径"
                  },
                  model: {
                    value: _vm.interfaceForm.url,
                    callback: function($$v) {
                      _vm.$set(_vm.interfaceForm, "url", $$v)
                    },
                    expression: "interfaceForm.url"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "资源描述：" } },
              [
                _c("el-input", {
                  attrs: {
                    size: "small",
                    type: "textarea",
                    placeholder: "请输入资源描述"
                  },
                  model: {
                    value: _vm.interfaceForm.desc,
                    callback: function($$v) {
                      _vm.$set(_vm.interfaceForm, "desc", $$v)
                    },
                    expression: "interfaceForm.desc"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "dialog-footer" }, [
      _c("input", {
        staticClass: "btn",
        attrs: { type: "button", value: "取消" },
        on: { click: _vm.cancelDailog }
      }),
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { type: "button", value: "确认" },
        on: {
          click: function($event) {
            return _vm.commit("interfaceForm")
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }